import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVerticalConnectorIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 2,
	height: 48,
	viewBox: "0 0 2 48",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 1v45.955",
		stroke: "#7a7370",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeDasharray: "0.1 5"
	})
});
export default SvgVerticalConnectorIcon;
